<template>
	<div class = "row" v-cloak>
		<div class="columns">
			<div class="panel">
				<div class="row">
					<div class="columns medium-offset-3 medium-8 end">
						<h3 class="">Settings - Payments</h3>
					</div>
				</div>

				<!-- <div class="row">
					<div class="columns medium-offset-3 medium-8">
						Choose what you would like parents to see at checkout
					</div>
				</div>

			<div class="row">
				<div class="columns">
					<ClientPaymentsBookingFee />
				</div>
			</div>			 -->

		</div>


		<div class="panel">


				<div class="row">
					<div class="columns">
						<h4>Payment Instructions for Parents/Guardians</h4>
					</div>
				</div>


				<div class="row">
					<div class="columns medium-6 end">
						<ClientPaymentSetting :setting="setting" v-for="(setting, index) in rulesJson" :key="'rule_' + index" />
					</div>
				</div>


				<div class="row">
					<div class="columns">
						<h4>Payment Methods You Accept</h4>
					</div>
				</div>

				<div class="row">
					<div class="columns medium-6" v-for="(setting, index) in settingsJson" :key="'setting_' + index">
						<ClientPaymentSetting :setting="setting"  />
					</div>
				</div>
			</div>



			<div class="panel callout">

				<div class="row">
					<div class="columns">
						<h4>What It Will Look Like</h4>
						<ul class="small-block-grid-2 medium-block-grid-3">
							<li v-for="eachSetting in settingsJson" v-if="paymentSettings[eachSetting.title_setting]=='true' && validLabel(eachSetting.inputs)">
								<AlternativePayment :setting="eachSetting"></AlternativePayment>
							</li>
						</ul>
					</div>
				</div>


			</div>


		</div>
	</div>
</template>



<script>

import { mapGetters } from 'vuex';
import ClientPaymentSetting from './ClientPaymentSetting';
import ClientPaymentsBookingFee from './ClientPaymentsBookingFee';
import AlternativePayment from './AlternativePayment';

export default {
	name: 'Client',
	data () {
		return  {

		}
	},


	methods : {
		validLabel: function(inputs){


			if(!(inputs.length > 0)) {
				return true
			}

			for (var i = 0; i < inputs.length; i++) {
				if (this.paymentSettings[inputs[i].setting]!=''){
					return true;
				}
			}
			return false;
		}
	},

	computed: {
		...mapGetters([
			'paymentSettings',
			'settingsJson',
			'rulesJson'
		]),
	},

	components: {
		ClientPaymentSetting,
		ClientPaymentsBookingFee,
		AlternativePayment
	},

	created () {
		this.$store.dispatch('GET_PAYMENT_SETTINGS')
			.then( response => this.$store.dispatch('GET_JSON'));

	}


}

</script>



<style scoped>

</style>
